// check where to position Footer component on page
export class FooterHelper {
  static checkWhereToPositionFooter(domElement: any): boolean {
    // check if space exceeds page height
    let section = document.getElementsByClassName(domElement)[0].offsetHeight;
    // get page size
    let colSize = document.getElementsByClassName("events-screen__col-8")[0]
      .offsetHeight;

    // select which is bigger
    if (section > colSize) {
      return false;
    } else {
      return true;
    }
  }
}
